./<template>
<div class="">
     <CCard v-if="hotelRoomObj">
      <CCardBody class="card-body pb-0px report_table_div-section">

               <span>
                
               </span>

        <table>
          <thead>
            <th>

            </th>
            <th>{{ $t("ratePlanAll.typeId") }}</th>
            <th>
              {{ $t("ratePlanAll.roomName") }}
            </th>
            <th>
              {{ $t("ratePlanAll.roomType") }}
            </th>
            <th>
              {{ $t("ratePlanAll.bedTypes") }}
            </th>
          </thead>
          <tbody>
            <tr>
              <td>
                 <cHotelThumbnail :imgURL="(hotelRoomObj.imageBaseurl && hotelRoomObj.imageUrlLow)?hotelRoomObj.imageBaseurl+hotelRoomObj.imageUrlLow:null" >

                 </cHotelThumbnail>
              </td>
              <td>
                {{ hotelRoomObj.roomid }}
              </td>
              <td>
                {{ hotelRoomObj.roomname }}
              </td>

              <td>
                {{ hotelRoomObj.roomtypes }}
              </td>

              <td>
                {{ hotelRoomObj.bedTypeNames.toString() }}
              </td>
            </tr>
          </tbody>
        </table>
      </CCardBody>
    </CCard>
</div>
  
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { COMPONENT_NAME, ORDER, PATHNAME } from "../../../../util/constants";
import router, { navigate } from "../../../../router/index";

import { mapGetters, mapActions } from "vuex";
import Logger from "../../../../services/logger";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  cloneDeep,
  OrderByList,GroupByList
} from "../../../../util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import apiGetRatePlan from "../../../../services/apiGetRatePlan";
import apiUpdateHotelGuestAgeSetup from "../../../../services/apiUpdateHotelGuestAgeSetup";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import cAlertModal from "../../../../components/form/cAlertModal";
import cHotelThumbnail from "../../../../components/hms/manage/hotelInfo/cHotelThumbnail";
export default {
    name:COMPONENT_NAME.C_ROOM_TYPE_INFO,
   
    props:{
        hotelRoomObj:{
            type:Object,
            default:null,
        }

    },

    components:{
      cHotelThumbnail
    }



}
</script>

<style>

</style>